/**
 *
 * Asynchronously loads the component for LayoutWrapper
 *
 */

import { lazyLoad } from 'utils/loadable';

export const LayoutWrapper = lazyLoad(
  () => import('./index'),
  module => module.LayoutWrapper,
);
